import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import A11y from 'chameleon/ui-stack/utilities/a11y';

import styles from './styles.css';

const RadioButton = (props) => {
  const { checked, onClick, disabled, accessibility, classes = {} } = props;

  const className = cn('flex justify-center items-center rounded-full', {
    'cursor-pointer': !disabled,
  });

  const iconClassName =
    classes.icon ||
    cn({
      'text-blue-700 stroke-current': checked,
      'text-gray-700 stroke-current': !checked,
      'text-blue-600 text-opacity-30': checked && disabled,
      [styles['disabled-radio-input']]: !checked && disabled,
    });

  return (
    <A11y>
      <div
        className={className}
        onClick={disabled ? null : onClick}
        tabIndex={0}
        role="radio"
        aria-checked={checked}
        {...accessibility}
      >
        <Icon
          className={iconClassName}
          id={checked ? 'radio_checked' : 'radio_unchecked'}
          disabled={disabled}
        />
      </div>
    </A11y>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  accessibility: PropTypes.shape({
    title: PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
  }),
  classes: PropTypes.object,
};

RadioButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  accessibility: {},
  classes: {},
};

export default RadioButton;
